import React from "react";
import { Box, Typography, Switch, Select, MenuItem, FormControl } from "@mui/material";
import typography from "../../../cssUtils/typography";
import { ColorsConstants } from "../../../cssUtils/constants";
import { selectFieldSx, labelSx, sectionLabelSx } from "../utils";

// Shared "Status" section — sits above Trigger Configuration in WorkflowEdit and
// CustomChatbotEdit. `group` is a fixed, non-editable classification of which
// Workflows-list table this entity belongs to (Custom / Configuration / Automation) —
// shown for context only, never sent back to the server.
const StatusSection = ({ isActive, onIsActiveChange, group }) => (
  <>
    <Typography sx={sectionLabelSx}>Status</Typography>
    <Box sx={{ display: "flex", gap: 3, mb: 3, flexDirection: "column" }}>
      <Box sx={{ flex: 1 }}>
        <Typography sx={labelSx}>Enabled</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, height: 40 }}>
          <Switch
            checked={isActive}
            onChange={(e) => onIsActiveChange(e.target.checked)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": { color: ColorsConstants.primaryBlue100 },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: ColorsConstants.primaryBlue100,
              },
            }}
          />
          <Typography
            sx={{
              ...typography.bodyLarge,
              fontWeight: 500,
              color: isActive ? "#2E7D32" : "#6C7C93",
            }}
          >
            {isActive ? "On" : "Off"}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={labelSx}>Group</Typography>
        <FormControl fullWidth size="small" disabled>
          <Select value={group} sx={selectFieldSx}>
            <MenuItem value={group} sx={{ ...typography.bodyLarge }}>
              {group}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  </>
);

export default StatusSection;
